<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin-top: 20px;">Create an organziation</h1>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div v-if="!statusSucceed" class="container">
            <!--<div class="alert alert-primary" role="alert">
                Organization is ...
            </div>-->

            <div class="form-group">
                <label for="Name">Name:</label>
                <input v-model="name" type="text" class="form-control" placeholder="Name of organization">
                <ValidationError context="Name" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="Description">Description:</label>
                <textarea v-model="description" class="form-control" placeholder="Description of organization"></textarea>
                <ValidationError context="Description" :errors="validationErrors"></ValidationError>
            </div>

            <button v-show="statusInitial || statusInvalid" @click="handleCreateOrganizationUnitCommandV1" type="button" class="btn btn-primary btn-lg">Create</button>
            <button v-show="statusInvoking" type="button" class="btn btn-primary btn-lg" disabled>Creating...</button>
        </div>

        <div v-else class="container">
            <h1>Congratulation!</h1>
            <h3>Organization was created. Now you can switch to this organization.</h3>
            <a class="btn btn-primary btn-lg" href="/#/admin/organizations/manage" role="button">Manage organizations</a>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import PageStatus from "@common/PageStatus";
    import VuePageQueries from "@Organizations/OrganizationUnits/Domain/queries-vue-component";
    import VuePageCommands from "@Organizations/OrganizationUnits/Domain/commands-vue-component";
    import "@common/Components/ValidationError.vue";

    @Component
    export default class CreateGlobalAdminPage extends mixins(PageBase, PageStatus, VuePageQueries, VuePageCommands) {
        name = '';
        description = '';

        mounted() {
            this.setTitle('Create an organziation');
        }

        handleCreateOrganizationUnitCommandV1() {
            this.setStatusInvoking();
            this.$clearValidationErrors();
            this.invokeCreateOrganizationUnitCommandV1('0', this.name, this.description);
        }

        succeedCreateOrganizationUnitCommandV1() {
            this.setStatusSucceed();
        }

        invalidCreateOrganizationUnitCommandV1(status) {
            this.$pushValidationErrors(status.ValidationErrors);
            this.setStatusInvalid();
        }

        failedCreateOrganizationUnitCommandV1(status) {
            this.setStatusFailed();
        }
    }
</script>

<style scoped>
</style>
